import { useEffect, useState } from 'react';

import { CloseIcon, LogoutIcon } from './icons';

export function LogoutConfirmModal({ onClose, onConfirm }: {
  onClose: () => void;
  onConfirm: () => Promise<void>;
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !submitting) onClose();
    };
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, [onClose, submitting]);

  async function confirm() {
    if (submitting) return;
    setSubmitting(true);
    setError('');
    try {
      await onConfirm();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Không thể đăng xuất. Vui lòng thử lại.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="drawer-backdrop" role="presentation">
      <section className="confirm-modal" role="dialog" aria-modal="true" aria-labelledby="logout-title" aria-describedby="logout-description">
        <header className="drawer-header"><h2 id="logout-title">Xác nhận đăng xuất</h2><button type="button" className="icon-button" onClick={onClose} disabled={submitting} aria-label="Đóng"><CloseIcon /></button></header>
        <div className="confirm-content">
          <p id="logout-description">Bạn có muốn đăng xuất khỏi KHO VTYT?</p>
          {error ? <div className="detail-error" role="alert">{error}</div> : null}
        </div>
        <footer className="drawer-footer"><button type="button" className="secondary-action" onClick={onClose} disabled={submitting} autoFocus>Hủy</button><button type="button" className="primary-action" onClick={() => void confirm()} disabled={submitting}>{submitting ? <span className="button-spinner" /> : <LogoutIcon />} {submitting ? 'Đang đăng xuất…' : 'Đăng xuất'}</button></footer>
      </section>
    </div>
  );
}
